import { getSingleSeries } from '../../../../api/series/index';
import EpisodesComponent from '../components/EpisodesComponent';
import Button from '../components/SeasonBtn';

export default function (page, { seriesId }) {
  return getSingleSeries(seriesId).then(({ data }) => {
    const series = data;
    // Create an array to hold the items for all episodes
    const items = [];

    const numberOfSeason = data.data.map((season, index) => ({
      type: Button,
      data: season,
      index,
      h: 70,
      data: {
        ...season,
        seriesId,
        seasonId: season.id,
      },
    }));
    // Loop through each season in series.data
    series.data[0].movies.forEach((movie, index) => {
      // Create an instance of EpisodesComponent for each movie
      const episodeComponent = {
        index,
        collision: true,
        w: 430,
        h: 220,
        type: EpisodesComponent,
        movieInfo: series,
        episodes: movie,
        src: movie['screenshot.expiring_url'],
      };

      // Push the episodeComponent to the items array
      items.push(episodeComponent);
    });

    // Set the items array in the _Column of the page
    page.episodes = series;
    page._Column.items = items;
    page._Season.items = numberOfSeason;
  });
}
